import React from "react";
import Hero from "../components/Hero";
import StatsCounter from "../components/StatsCounter";
import MasonryIntro from "../components/MasonryIntro";
import ServicesPreview from "../components/ServicesPreview";
import ProjectsGallery from "../components/ProjectsGallery";
import WhyChooseUs from "../components/WhyChooseUs";
import Testimonials from "../components/Testimonials";
import ServiceAreas from "../components/ServiceAreas";
import FaqSection from "../components/FaqSection";
import FinalCta from "../components/FinalCta";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <StatsCounter />
      <MasonryIntro />
      <ServicesPreview />
      <ProjectsGallery />
      <WhyChooseUs />
      <Testimonials />
      <ServiceAreas />
      <FaqSection />
      <FinalCta />
    </main>
  );
}
